// extracted by mini-css-extract-plugin
export var fadeInAnimation = "HeroVideo-module--fadeInAnimation--fe745";
export var show = "HeroVideo-module--show--229a0";
export var video = "HeroVideo-module--video--9a7a4";